import { render, staticRenderFns } from "./NotiList.vue?vue&type=template&id=f6959a4c&scoped=true&"
import script from "./NotiList.vue?vue&type=script&lang=js&"
export * from "./NotiList.vue?vue&type=script&lang=js&"
import style0 from "./NotiList.vue?vue&type=style&index=0&id=f6959a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6959a4c",
  null
  
)

export default component.exports